import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fg } from '@atlaskit/platform-feature-flags';
import calculateTTVCPercentiles from './percentile-calc';
import getViewportHeight from './utils/get-viewport-height';
import getViewportWidth from './utils/get-viewport-width';
var AbstractVCCalculatorBase = /*#__PURE__*/function () {
  function AbstractVCCalculatorBase(revisionNo) {
    _classCallCheck(this, AbstractVCCalculatorBase);
    this.revisionNo = revisionNo;
  }
  return _createClass(AbstractVCCalculatorBase, [{
    key: "calculate",
    value: function () {
      var _calculate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var _this = this,
          _vcDetails$90$t,
          _vcDetails$;
        var startTime, stopTime, orderedEntries, filteredEntries, _this$getVCCleanStatu, _isVCClean, dirtyReason, _isVCClean2, vcDetails;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              startTime = _ref.startTime, stopTime = _ref.stopTime, orderedEntries = _ref.orderedEntries;
              filteredEntries = orderedEntries.filter(function (entry) {
                return _this.isEntryIncluded(entry);
              });
              if (!fg('platform_ufo_add_vc_abort_reason_by_revisions')) {
                _context.next = 8;
                break;
              }
              _this$getVCCleanStatu = this.getVCCleanStatus(filteredEntries), _isVCClean = _this$getVCCleanStatu.isVCClean, dirtyReason = _this$getVCCleanStatu.dirtyReason;
              if (_isVCClean) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", {
                revision: this.revisionNo,
                'metric:vc90': null,
                clean: false,
                abortReason: dirtyReason
              });
            case 6:
              _context.next = 11;
              break;
            case 8:
              _isVCClean2 = this.isVCClean(filteredEntries);
              if (_isVCClean2) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return", {
                revision: this.revisionNo,
                'metric:vc90': null,
                clean: false
              });
            case 11:
              _context.next = 13;
              return calculateTTVCPercentiles({
                viewport: {
                  width: getViewportWidth(),
                  height: getViewportHeight()
                },
                startTime: startTime,
                stopTime: stopTime,
                orderedEntries: filteredEntries,
                percentiles: [25, 50, 75, 80, 85, 90, 95, 98, 99]
              });
            case 13:
              vcDetails = _context.sent;
              return _context.abrupt("return", {
                revision: this.revisionNo,
                clean: true,
                'metric:vc90': (_vcDetails$90$t = vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails['90']) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t) !== null && _vcDetails$90$t !== void 0 ? _vcDetails$90$t : null,
                vcDetails: vcDetails !== null && vcDetails !== void 0 ? vcDetails : undefined
              });
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function calculate(_x) {
        return _calculate.apply(this, arguments);
      }
      return calculate;
    }()
  }]);
}();
export { AbstractVCCalculatorBase as default };